// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1l0NN","left":"InfoRow_left__3EBef"};